import React from "react";

import { useI18n } from "@/context/i18n";

import { LoadingIcon } from "./loading-icon";

export const Loading: React.FC = () => {
  const { t } = useI18n();

  return (
    <div
      id="loading"
      className="fixed z-[999] inset-0 overflow-y-auto bg-black/80 hidden"
    >
      <div className="flex flex-col items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center">
        <LoadingIcon className="w-24 h-24 text-foreground/80" />
        <p className="text-2xl font-semibold text-white text-center mt-8">
          {t("components.loading.loading")}
        </p>
      </div>
    </div>
  );
};
